import StoreBadges from "@/components/StoreBadges";

const CTABanner = () => (
  <section data-testid="cta-banner" className="border-t border-divider py-24">
    <div className="mx-auto max-w-6xl px-4 sm:px-6">
      <div className="grain relative overflow-hidden rounded-lg bg-gradient-to-br from-brand to-navy px-8 py-16 text-center sm:px-16">
        <h2 className="font-display text-3xl font-bold uppercase tracking-wide text-white sm:text-4xl">
          Your next sale is one photo away
        </h2>
        <p className="mx-auto mt-4 max-w-md text-sm text-white/80">
          Download Sellcraft and post your first listing in under a minute.
        </p>
        <div className="mt-8 flex justify-center">
          <StoreBadges testIdPrefix="cta-banner" />
        </div>
      </div>
    </div>
  </section>
);

export default CTABanner;
